<template>
  <v-container fluid>
    <v-row>
      <v-col xs12 md8 offset-md2>
        <v-card class="grey lighten-4 elevation-0">
          <v-toolbar>
            <v-toolbar-title>加入會員</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>帳號</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="username"
                    name="input-1-5"
                    label="帳號"
                    v-model="user.username"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>密碼</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="password"
                    name="input-2-5"
                    label="密碼"
                    type="password"
                    class="input-group"
                    v-model="user.password"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>密碼確認</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    name="input-3-5"
                    label="密碼確認"
                    type="password"
                    value=""
                    class="input-group"
                    v-model="password_confirm"
                    v-bind:rules="[() => { return user.password !== password_confirm ? '與密碼不一致' : true}]"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>姓名</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="realname"
                    name="input-4-5"
                    label="姓名"
                    value=""
                    v-model="user.realname"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>聯絡電話</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="phone"
                    name="input-5-5"
                    label="聯絡電話"
                    value=""
                    class="input-group"
                    v-model="user.phone"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>

            <v-card-row actions class="mt-4">
              <v-btn small primary dark v-on:click.native="validation()">註冊</v-btn>
            </v-card-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'
  import api from '../api'

  export default {

    name: 'Register',

    data () {
      return {
        user: {
          username: '',
          password: '',
          realname: '',
          phone: ''
        },
        password_confirm: ''
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '註冊',
        link: '/order'
      })
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb',
        'setErrorMessage'
      ]),

      register () {
        var self = this
        api.Account.Register(this.user)
          .then((res) => {
            alert('註冊成功')
            self.$router.push('/login')
          })
          .catch((error) => {
            console.log(error)
          })
      },

      validation () {
        var valid = true
        var message = ''

        if (this.user.username === '' ||
            this.user.password === '' ||
            this.user.realname === '' ||
            this.user.phone === '') {
          message = '請輸入必填欄位'
          this.$refs.phone.focus()
          this.$refs.password.focus()
          this.$refs.realname.focus()
          this.$refs.username.focus()
          valid = false
        }

        if (this.user.password !== '' &&
          this.user.password !== this.password_confirm) {
          message = message.length > 0 ? message + '，' : ''
          message += '密碼與確認密碼不一致'
          this.$refs.password.focus()
          valid = false
        }

        if (valid) {
          this.register()
        } else {
          this.setErrorMessage(message)
          return false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?b80b10cc